// import React from "react";
// import Leadership from "./Leadership";
// import "./Leadership.css";

// const leadershipMembers = [
//   {
//     name: "Rajesh N",
//     role: "Founder",
//     image: "./assets/team/rajesh.jpeg",
//     description:
//       "Rajesh N Director, SLR Public School (5+ Years) Driving academic excellence, institutional growth, and digital transformation,Professional Background:18+ years of experience in Sales, Business Development, Customer Relationship Management, and Leadership across Tremco CPG, Fosroc, Don Construction Products, LG Electronics, and NCC Urban Infrastructure Limited,Core Expertise:Educational Leadership | Business Development | Sales & Marketing | Strategic Planning | Revenue Growth | Key Account Management |Customer Relationship Management | Digital Transformation",
//   },
//   {
//     name: "Dhanraj N",
//     role: "Co-Founder, Director",
//     image: "./assets/team/Dhanraj.png",
//     description:
//       "Dhanraj N - Director, SLR Public School (10+ Years) Leading educational excellence, institutional growth, and digital transformation initiatives. Exclusive Managing Director – Financial , Gandure Ventures (6+ Years) | Business Growth | Financial Management | Digital Transformation polish.",
//   },
//   {
//     name: "Roopa Srinivas",
//     role: "Director",
//     image: "./assets/team/roopa.png",
//     description:
//       "Roopa Srinivas - School Trustee, SLR Public School (10+ Years) | Educational Leadership | Institutional Growth | Digital Transformation | Strategic Governance .",
//   },
//   {
//     name: "Pushpa Ranganath",
//     role: "Vice President",
//     image: "./assets/team/director2.png",
//     description:
//       "Pushpa Ranganath - School Trustee, SLR Public School (10+ Years)| Dental Doctor (20+ Years of Experience) | Dental Care & Healthcare Management | Educational Leadership | Company Growth | Digital Transformation | Strategic Governance | Organizational Development | Leadership & Mentoring.",
//   },
//   {
//     name: "Nagarathna M",
//     role: "Sales and Marketing Director",
//     image: "./assets/team/nagarathna.png",
//     linkedin: "https://www.linkedin.com/in/nagarathna-muthurayappa-6a817031",
//     description:
//       "Nagarathna - Director of Sales & Marketing | Executive Director – IT @ SLR Public School Product Management & Delivery | Digital Transformation | Cloud ERP Solutions | CRM | Procurement Automation | Business Process Optimization | Sales & Marketing Strategy | Business Development | Client Success | Technology Leadership | Stakeholder Management",
//   },
//   {
//     name: "Manjunath G",
//     role: "Vice President of Sales",
//     image: "./assets/team/manjunath.jpeg",
//     description:
//       "Manjunath - Managing Director – Finance | Gandure Ventures (15+ Years)Business Growth | Financial Management | Digital Transformation | Sales & Marketing Strategy | Business Development | Client Success | Technology Leadership | Stakeholder Management",
//   },
//   {
//     name: "Aditya M V",
//     role: "Product Innovation Lead",
//     image: "./assets/team/aditya.png",
//     description:
//       "Aditya M V focuses on Product Strategy | Innovation Management | Product Development | Market Analysis | Stakeholder Management | Customer Experience | Business Growth | Digital Transformation.",
//   },
//   {
//     name: "Reshmi S",
//     role: "Human Resources",
//     image: "./assets/team/reshmihr.png",
//     description:
//       "Talent Acquisition | Employee Relations | HR Operations | Performance Management | Payroll & Compliance | Training & Development | Employee Engagement | Workforce Planning",
//   },
// ];

// const LeadershipTeam = () => {
//   return (
//     <div className="leadership-section">
//       <h1 className="leadership-heading">Leadership Team</h1>
//       <div className="leadership-grid">
//         {leadershipMembers.map((member, index) => (
//           <Leadership
//             key={index}
//             member={member}
//             members={leadershipMembers}
//             index={index}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default LeadershipTeam;

import React from "react";
import Leadership from "./Leadership";
import "./Leadership.css";

const leadershipMembers = [
  {
    name: "Rajesh N",
    role: "Director",
    image: "./assets/team/rajesh.jpeg",
    objectPosition: "center 15%",
    description:
      "Rajesh N Director, SLR Public School (5+ Years) Driving academic excellence, institutional growth, and digital transformation. Professional Background: 18+ years of experience in Sales, Business Development, Customer Relationship Management, and Leadership across Tremco CPG, Fosroc, Don Construction Products, LG Electronics, and NCC Urban Infrastructure Limited. Core Expertise: Educational Leadership | Business Development | Sales & Marketing | Strategic Planning | Revenue Growth | Key Account Management | Customer Relationship Management | Digital Transformation",
  },
  {
    name: "Dhanraj N",
    role: "Director",
    image: "./assets/team/Dhanraj.png",
    objectPosition: "center 15%",
    description:
      "Dhanraj N - Director, SLR Public School (10+ Years) Leading educational excellence, institutional growth, and digital transformation initiatives. Exclusive Managing Director – Financial, Gandure Ventures (6+ Years) | Business Growth | Financial Management | Digital Transformation polish.",
  },
  {
    name: "Roopa Srinivas",
    role: "Director",
    image: "./assets/team/roopa.jpeg",
    objectPosition: "center 15%",
    description:
      "Roopa Srinivas - School Trustee, SLR Public School (10+ Years) | Educational Leadership | Institutional Growth | Digital Transformation | Strategic Governance.",
  },
  {
    name: "Pushpa Ranganath",
    role: "Vice President",
    image: "./assets/team/director2.jpeg",
    objectPosition: "center 15%",
    description:
      "Pushpa Ranganath - School Trustee, SLR Public School (10+ Years)| Dental Doctor (20+ Years of Experience) | Dental Care & Healthcare Management | Educational Leadership | Company Growth | Digital Transformation | Strategic Governance | Organizational Development | Leadership & Mentoring.",
  },
  {
    name: "Nagarathna M",
    role: "Sales and Marketing Director",
    image: "./assets/team/nagarathna.png",
    objectPosition: "center 15%",
    linkedin: "https://www.linkedin.com/in/nagarathna-muthurayappa-6a817031",
    description:
      "Nagarathna - Director of Sales & Marketing | Executive Director – IT @ SLR Public School Product Management & Delivery | Digital Transformation | Cloud ERP Solutions | CRM | Procurement Automation | Business Process Optimization | Sales & Marketing Strategy | Business Development | Client Success | Technology Leadership | Stakeholder Management",
  },
  {
    name: "Manjunath G",
    role: "Vice President of Sales",
    image: "./assets/team/manjunath.jpeg",
    objectPosition: "center 15%",
    description:
      "Manjunath - Managing Director – Finance | Gandure Ventures (15+ Years)Business Growth | Financial Management | Digital Transformation | Sales & Marketing Strategy | Business Development | Client Success | Technology Leadership | Stakeholder Management",
  },
  {
    name: "Aditya M V",
    role: "Product Innovation Lead",
    image: "./assets/team/aditya.png",
    objectPosition: "center 15%",
    description:
      "Aditya M V focuses on Product Strategy | Innovation Management | Product Development | Market Analysis | Stakeholder Management | Customer Experience | Business Growth | Digital Transformation.",
  },
  {
    name: "Reshmi S",
    role: "Human Resources",
    image: "./assets/team/reshmihr.png",
    objectPosition: "center 15%",
    description:
      "Talent Acquisition | Employee Relations | HR Operations | Performance Management | Payroll & Compliance | Training & Development | Employee Engagement | Workforce Planning",
  },
];

const LeadershipTeam = () => {
  return (
    <div className="leadership-section">
      <div className="leadership-wrapper">
        <h1 className="leadership-heading">Leadership Team</h1>
        <div className="leadership-grid">
          {leadershipMembers.map((member, index) => (
            <Leadership
              key={index}
              member={member}
              members={leadershipMembers}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadershipTeam;